<form [formGroup]="loonBuitenland">
    <div *ngIf="loonUitBuitenland.length > 0" class="row">
        <div formArrayName="loonUitBuitenland">
            <div *ngFor="let loon of loonUitBuitenland.controls; let i = index;"
                 [formGroupName]="i" class="row">
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Land' : ''"
                                                  [options]="optionsLandcodes"
                                                  [required]=true
                                                  class="col-auto custom-input-150"
                                                  formControlName="landCode"
                >
                </snelstart-ui-select-form-control>
                <div class="col-auto row" formGroupName="loon">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Buitenlandse werkgever/instantie' : ''"
                                                    class="col-auto custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Loon/pensioen' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="col-auto custom-input-150"
                                                      formControlName="bedrag"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="row col-auto">
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Nederl. loonheffing' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="col-auto custom-input-150"
                                                      formControlName="loonheffing"
                                                      id="loonheffing"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [label]="i === 0 ? 'Soort inkomen' : ''"
                        [options]="optionsTegenwoordig"
                        [required]=true
                        class="col-auto custom-input-250"
                        formControlName="loonUitTegenwoordigeBuitenlandseDienstbetrekking"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-button (click)="this.showDialog(i)"
                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                     class="col-auto"
                                     icon="plus"
                                     type="secondary">Meer gegevens
                </snelstart-ui-button>
                <div class="col-auto">
                    <snelstart-ui-button (click)="verwijderRijLoonBuitenland(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         class="delete"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="loonUitBuitenland.length === 0">
    <snelstart-ui-button (click)="addRijLoonBuitenland()" class="snelstart-ui-button" icon="plus"
                         type="link">Loon buitenland invullen
    </snelstart-ui-button>
</div>
<div *ngIf="loonUitBuitenland.length > 0">
    <snelstart-ui-button (click)="addRijLoonBuitenland()" class="snelstart-ui-button" icon="plus"
                         type="link">Loon toevoegen
    </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="loonBuitenlandBijzonderheden" size="lg"
                                title="Gegevens buitenlands inkomen">
    <snelstart-ui-dialog-body>
        <form [formGroup]="loonBuitenland">
            <div class="pt-2" formArrayName="loonUitBuitenland">
                <div *ngFor="let loon of loonUitBuitenland.controls; let i = index;"
                     [formGroupName]="i">
                    <div *ngIf="i === this.index">
                        <div class="row me-2">
                            <div class="col col-1">
                                <p>Dient het buitenlands inkomen tot de Nederlandse grondslag gerekend te
                                    worden?</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-select-form-control
                                        (change)="saveForm()"
                                        [options]="optionsJaNee"
                                        class="custom-input-150"
                                        formControlName="inkomenZitInNederlandseGrondslag"
                                        id="inkomenZitInNederlandseGrondslag"

                                >
                                </snelstart-ui-select-form-control>
                            </div>
                        </div>
                        <div *ngIf="loonUitBuitenland.controls[i].get('inkomenZitInNederlandseGrondslag')?.value === true">
                            <div class="row me-2">
                                <div class="col col-1">
                                    <p>Vermeld het in Nederland belaste deel van het buitenlandse inkomen</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="belastDeelLoonInNederland"
                                                                      id="belastDeelLoonInNederland"
                                                                      prefix="€"

                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                            </div>
                        </div>
                        <div class="row me-2">
                            <div class="col col-1">
                                <p>Is de verrekenmethode (verrekenen buitenlandse loonheffing) van toepassing?</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-select-form-control (change)="saveForm()"
                                                                  [options]="optionsJaNee"
                                                                  class="custom-input-150"
                                                                  formControlName="pasVerrekenMethodeToe"
                                                                  id="pasVerrekenMethodeToe"

                                >
                                </snelstart-ui-select-form-control>
                            </div>
                        </div>
                        @if (this.loonUitBuitenland.controls[i].get('pasVerrekenMethodeToe')?.value === true) {
                            <div class="row me-2">
                                <div class="col col-1">
                                    <p>Vermeld de ingehouden buitenlandse loonheffing</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="buitenlandseLoonheffing"
                                                                      id="buitenlandseLoonheffing"
                                                                      prefix="€"

                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                            </div>
                        }

                        <div class="row me-2">
                            <div class="col col-1">
                                <p>Is er in Nederland premie zorgverzekeringswet verschuldigd over het
                                    buitenlandse inkomen?</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-select-form-control (change)="saveForm()"
                                                                  [options]="optionsJaNee"
                                                                  class="custom-input-150"
                                                                  formControlName="afdrachtZVWinNLmoetnog"
                                                                  id="afdrachtZVWinNLmoetnog"
                                >
                                </snelstart-ui-select-form-control>
                            </div>
                        </div>
                        @if (loonUitBuitenland.controls[i].get('landCode')?.value === 'BEL' &&
                        loonUitBuitenland.controls[i].get('loonUitTegenwoordigeBuitenlandseDienstbetrekking')?.value === true) {
                            <div class="row me-2">
                                <div class="col col-1">
                                    <p>Is de algemene compensatieregeling van toepassing?</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                                      [options]="optionsJaNeeSter"
                                                                      class="custom-input-150"
                                                                      formControlName="benutAlgemeneCompensatieregeling"
                                                                      id="benutAlgemeneCompensatieregeling"
                                    >
                                    </snelstart-ui-select-form-control>
                                </div>
                            </div>
                            <div class="row me-2">
                                <div class="col col-1">
                                    <p>Is de bijzondere compensatieregeling van toepassing?</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                                      [options]="optionsJaNeeSter"
                                                                      class="custom-input-150"
                                                                      formControlName="benutBijzondereCompensatieregeling"
                                                                      id="benutBijzondereCompensatieregeling"
                                    >
                                    </snelstart-ui-select-form-control>
                                </div>
                            </div>


                            <div class="row me-2">
                                <div class="col col-1">
                                    <p>Is er sprake van verandering van werkgever?</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-select-form-control
                                            (change)="saveForm()"
                                            [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="veranderingVanWerkgever"
                                            id="veranderingVanWerkgever"
                                    >
                                    </snelstart-ui-select-form-control>
                                </div>
                            </div>
                        }
                        @if (loonUitBuitenland.controls[i].get('landCode')?.value === 'DEU' &&
                        loonUitBuitenland.controls[i].get('loonUitTegenwoordigeBuitenlandseDienstbetrekking')?.value === true &&
                        loonUitBuitenland.controls[i].get('loon.bedrag')?.value > loonUitBuitenland.controls[i].get('belastDeelLoonInNederland')?.value) {
                            <div class="row me-2">
                                <div class="col col-1">
                                    <p>Is de compensatieregeling Duitsland van toepassing vanwege werken in
                                        Duitsland?</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                                      [options]="optionsJaNeeSter"
                                                                      class="custom-input-150"
                                                                      formControlName="compensatieregelingDuitsland"
                                                                      id="compensatieregelingDuitsland"
                                    >
                                    </snelstart-ui-select-form-control>
                                </div>
                            </div>
                        }

                        @if (this.loonUitBuitenland.controls[i].get('compensatieregelingDuitsland')?.value === true || this.loonUitBuitenland.controls[i].get('benutAlgemeneCompensatieregeling')?.value === true || this.loonUitBuitenland.controls[i].get('benutBijzondereCompensatieregeling')?.value === true) {
                            <div class="row me-2">
                                <div class="col col-1">
                                    @if (this.loonUitBuitenland.controls[i].get('compensatieregelingDuitsland')?.value === true) {
                                    <p>Vermeld de in Duitsland ingehouden loonbelasting (Lohnsteuer en Solidaritätszuschlag)</p>
                                    } @else {
                                    <p>Vermeld de in België ingehouden loonbelasting (Bedrijfsvoorheffing)</p>
                                    }

                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="inBelgieOfDuitslandIngehoudenBelasting"
                                                                      id="inBelgieOfDuitslandIngehoudenBelasting"
                                                                      prefix="€"

                                    >
                                    </snelstart-ui-number-form-control>
                                </div>

                                <div class="space20"></div>
                                <p>* Bij de berekening van de verschuldigde belasting wordt in deze aangifte geen rekening gehouden met de compensatieregeling. Bij de definitieve aanslag houdt de Belastingdienst daar wel rekening mee.</p>
                            </div>
                        }


                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>




